import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api, { inr } from "@/api";
import { Reveal, Overline, Magnetic } from "@/components/Motion";

export default function ArtworkDetail() {
  const { id } = useParams();
  const [a, setA] = useState(null);

  useEffect(() => {
    api.get(`/artworks/${id}`).then((r) => setA(r.data)).catch(() => setA(false));
  }, [id]);

  if (a === false) return <main className="pt-40 px-6 md:px-12 min-h-screen"><p className="font-mono text-sm">Artwork not found.</p></main>;
  if (!a) return <main className="pt-40 px-6 md:px-12 min-h-screen"><p className="font-mono text-sm text-ink/40">Loading…</p></main>;

  return (
    <main data-testid="artwork-detail" className="pt-28 pb-24 px-6 md:px-12 max-w-7xl mx-auto min-h-screen">
      <Link to="/work/art" data-testid="back-to-art" className="link-line inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-ink/60">
        <ArrowLeft size={14} /> All Art
      </Link>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mt-10 items-start">
        <Reveal className="lg:col-span-7">
          <div className="frame-clip spotlight bg-linen border border-ink/10 p-4 md:p-8">
            <img src={a.image} alt={a.title} className="w-full h-auto" />
          </div>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5">
          <Overline>{a.category}</Overline>
          <h1 className="font-display text-4xl md:text-5xl tracking-tight mt-4">{a.title}</h1>
          <dl className="mt-8 space-y-4 border-t border-ink/15 pt-6">
            {[["Medium", a.medium], ["Size", a.size], ["Year", a.year]].map(([k, v]) => (
              <div key={k} className="flex justify-between gap-6">
                <dt className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink/40 pt-1">{k}</dt>
                <dd className="font-display text-lg text-right">{v}</dd>
              </div>
            ))}
          </dl>
          <p className="mt-8 text-ink/60 leading-relaxed">{a.description}</p>
          {a.for_sale ? (
            <div className="mt-10">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-ink/40">Price</p>
              <p className="font-display text-3xl mt-2">{inr(a.price)}</p>
              <Magnetic>
                <Link to={`/contact?type=Artwork Commission&subject=${encodeURIComponent(a.title)}`}
                  data-testid="artwork-enquire-btn"
                  className="mt-6 inline-flex items-center gap-3 bg-ink text-paper px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-brand transition-colors">
                  Enquire to Purchase
                </Link>
              </Magnetic>
            </div>
          ) : (
            <p className="mt-10 font-mono text-xs uppercase tracking-[0.2em] text-ink/40 border border-ink/15 inline-block px-4 py-2">
              Not for sale — studio archive
            </p>
          )}
        </Reveal>
      </div>
    </main>
  );
}
